import type { FC } from "react";
import type { Reward } from "../../types";
import AmountPill from "../AmountPill";
import RewardPill from "./RewardPill";

type Props = {
  reward: Reward;
};

const RewardPayload: FC<Props> = ({ reward }) => {
  const chosen = reward.options?.find(
    (option) => option.id === reward.chosenOptionId,
  );
  const items = chosen?.items ?? reward.items;

  if (items) {
    return (
      <span data-slot="reward-payload" className="flex -space-x-1.5">
        {items.map((item) => (
          <RewardPill key={item.label} item={item} />
        ))}
      </span>
    );
  }
  if (reward.amount) return <AmountPill amount={reward.amount} />;
  return null;
};

export default RewardPayload;
